export type PayrollStatusPillThemeType = 'info' | 'warning' | 'success' | 'secondary'

const EMPLOYMENT_STATUS_DAILY_WORKER = 'Daily Worker'
const EMPLOYMENT_STATUS_FULL_TIME = 'Full Time'

export const EMPLOYMENT_STATUS_PILL_THEME_MAP: Record<string, PayrollStatusPillThemeType> = {
  [EMPLOYMENT_STATUS_DAILY_WORKER]: 'warning',
  [EMPLOYMENT_STATUS_FULL_TIME]: 'info',
}

export const getEmploymentStatusPillTheme = (
  employmentStatus: string,
): PayrollStatusPillThemeType => EMPLOYMENT_STATUS_PILL_THEME_MAP[employmentStatus] ?? 'secondary'
